import { render, staticRenderFns } from "./ReturnCreate.vue?vue&type=template&id=2a0a7e70&scoped=true"
import script from "./ReturnCreate.vue?vue&type=script&lang=js"
export * from "./ReturnCreate.vue?vue&type=script&lang=js"
import style0 from "./ReturnCreate.vue?vue&type=style&index=0&id=2a0a7e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0a7e70",
  null
  
)

export default component.exports